import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const ManagementScope = ({ 
  managementLevel, 
  onManagementLevelChange,
  teamSize,
  onTeamSizeChange,
  directReports,
  onDirectReportsChange
}) => {
  const managementLevelOptions = [
    { value: 'individual', label: 'Individual Contributor', description: 'No direct reports' },
    { value: 'team-lead', label: 'Team Lead', description: 'Leading small team or project' },
    { value: 'manager', label: 'Manager', description: 'Managing team with direct reports' },
    { value: 'senior-manager', label: 'Senior Manager', description: 'Managing multiple teams' },
    { value: 'director', label: 'Director', description: 'Managing managers and departments' },
    { value: 'vp', label: 'VP/Executive', description: 'Strategic leadership across organization' }
  ];

  const teamSizeOptions = [
    { value: '0', label: 'No team management' },
    { value: '1-5', label: '1-5 people' },
    { value: '6-10', label: '6-10 people' },
    { value: '11-20', label: '11-20 people' },
    { value: '21-50', label: '21-50 people' },
    { value: '51-100', label: '51-100 people' },
    { value: '100+', label: '100+ people' }
  ];

  const showTeamDetails = managementLevel && managementLevel !== 'individual';

  return (
    <div className="w-full">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
        Management Scope
      </h2>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-6 md:mb-8">
        Tell us about your leadership and management responsibilities
      </p>
      <div className="space-y-6">
        <Select
          label="Management Level"
          description="Select your current management responsibility"
          options={managementLevelOptions}
          value={managementLevel}
          onChange={onManagementLevelChange}
          required
        />

        {showTeamDetails && (
          <>
            <Select
              label="Total Team Size"
              description="Total number of people in your organization/team"
              options={teamSizeOptions}
              value={teamSize}
              onChange={onTeamSizeChange}
              required
            />

            <Input
              type="number"
              label="Number of Direct Reports"
              description="How many people report directly to you?"
              placeholder="Enter number"
              value={directReports}
              onChange={(e) => onDirectReportsChange(e?.target?.value)}
              min="0"
              max="100"
              required
            />
          </>
        )}

        <div className="p-4 md:p-6 rounded-xl bg-muted">
          <p className="text-sm md:text-base text-muted-foreground">
            <strong className="text-foreground">Note:</strong> Management experience is valued but not required. Individual contributors with deep expertise are equally important to our platform.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ManagementScope;